export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YOZqilQs6yLUrwB0lw.d6532a7b.woff2";